import { useEffect, useRef } from "react";
import { usePageVisibility } from "react-page-visibility";

function usePolling(callback: (...args: any[]) => void, delay: number, pause?: boolean) {
    const savedCallback = useRef<(...args: any[]) => void>();

    const isVisible = usePageVisibility();

    useEffect(() => {
        savedCallback.current = callback;
    });

    useEffect(() => {
        if (pause || !isVisible) {
            return;
        }

        const id = setInterval(() => savedCallback.current && savedCallback.current(), delay);
        return () => clearInterval(id);
    }, [delay, pause, isVisible]);
}

export default usePolling;
